import { useQuery } from '@tanstack/react-query';
import { clientRelationshipsApi } from '../api/clientRelationshipsApi';
import type { ClientListParams } from '../types/client.types';

/**
 * React Query keys for client relationship data.
 * Used by all features that read/invalidate client data.
 */
export const clientKeys = {
  all: ['clients'] as const,
  list: (params?: ClientListParams) => ['clients', 'list', params] as const,
  detail: (clientUserId: string) =>
    ['clients', 'detail', clientUserId] as const,
};

/**
 * Hook to fetch paginated client list for the authenticated professional.
 *
 * @param params - Optional pagination/search params (page, limit, search)
 * @param enabled - Whether the query should execute (default: true)
 * @returns React Query result with { data: Client[], meta: PaginationMeta }
 */
export function useClients(params?: ClientListParams, enabled = true) {
  return useQuery({
    queryKey: clientKeys.list(params),
    queryFn: () => clientRelationshipsApi.getClients(params),
    enabled,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: true,
  });
}
